export default __webpack_public_path__ + "static/media/litho-demo-personal-portfolio.23c1f178.jpg";